import type { ExplorationVolume } from '../types/exploration';
import { isDrillLocationEmpty } from './drill/drillLocation';
import {
  volumesInCurrentScope,
  type VolumesInCurrentScopeOptions,
} from './sidebar/volumesInCurrentScope';

export type ExplorationCanvasScopeOptions = VolumesInCurrentScopeOptions & {
  view: NonNullable<VolumesInCurrentScopeOptions['view']>;
};

/** True when global filters match volumes but the current drill scope has none. */
export function isExplorationScopeEmptyFromCounts(
  filteredLength: number,
  drillPathLength: number,
  scopedVolumeCount: number
): boolean {
  return filteredLength > 0 && drillPathLength > 0 && scopedVolumeCount === 0;
}

/** True when global filters match volumes but the current drill scope has none. */
export function isExplorationCanvasScopeEmpty(
  filtered: ExplorationVolume[],
  opts: VolumesInCurrentScopeOptions
): boolean {
  if (!filtered.length || isDrillLocationEmpty(opts.location)) return false;
  const scoped = volumesInCurrentScope(filtered, opts);
  return isExplorationScopeEmptyFromCounts(filtered.length, 1, scoped.length);
}
